import {
  Company,
  CompanyType,
  IdentityParameter,
  PageNumberBasedListRequest,
  PageNumberBasedListResponse,
} from "@/features/types";
import useFetcher from "@/utils/use-fetcher";
import { Identity } from "@/features/ui/hooks/use-identity";
import {
  isIdentity,
  toIdentityParameter,
} from "@/features/ui/helpers/identity-helpers";
import { getUrlPrefixByIdentityParameter } from "@/features/ui/helpers/zwr-helpers";
import useSWR, { SWRConfiguration } from "swr";
import { IssuedBy } from "@/features/invoices/triangular-trades/triangular-trade.type";
//
// export interface ListIssuedByListWithoutPagingRequest {
//   type__in?: CompanyType[];
// }

export interface ListIssuedByListRequest extends PageNumberBasedListRequest {}

export interface ListIssuedByListResponse extends PageNumberBasedListResponse {
  issuedByList: IssuedBy[];
}

export interface ListIssuedByListPathParameter extends IdentityParameter {}

export function getListIssuedByListPathParameter(
  identity: Identity | null
): ListIssuedByListPathParameter | null {
  return toIdentityParameter(identity);
}

export function getListIssuedByListKey(
  identityOrParameter?: Identity | ListIssuedByListPathParameter | null,
  request?: ListIssuedByListRequest
) {
  if (identityOrParameter) {
    let parameter;
    if (isIdentity(identityOrParameter)) {
      parameter = getListIssuedByListPathParameter(identityOrParameter)!!;
    } else {
      parameter = identityOrParameter;
    }
    const prefix = getUrlPrefixByIdentityParameter(parameter);
    return {
      url: `${prefix}/issued_by`,
      params: request,
    };
  }
  return null;
}

export default function useListIssuedByList(
  parameter?: ListIssuedByListPathParameter | null,
  request?: ListIssuedByListRequest,
  config?: SWRConfiguration
) {
  const fetcher = useFetcher<
    ListIssuedByListRequest,
    ListIssuedByListResponse
  >();
  return useSWR(getListIssuedByListKey(parameter, request), fetcher, config);
}
